import { useQuery } from '@tanstack/react-query'
import { gpuApi } from '@/api/gpu'

export function useGPUStats() {
  return useQuery({
    queryKey: ['gpu-stats'],
    queryFn: gpuApi.stats,
    refetchInterval: 15_000,
    retry: 1,
  })
}
